export default __webpack_public_path__ + "static/media/load.8d415f76.gif";